"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const react_jss_1 = __importDefault(require("react-jss"));
const tooltip_style_1 = __importDefault(require("./tooltip.style"));
const position_1 = require("./position");
const Tooltip = ({ classes, clientEl, portalEl, children, position = {
    place: 'right',
    placeShift: 3,
    adjustPlace: true
}, arrowUp = null, delay = 0 }) => {
    // use callback to reposition the tooltip when it finished mounting
    // wait until 'delay' to actually display it
    const arrowRef = react_1.useRef(null);
    const tooltipRef = react_1.useRef(null);
    react_1.useEffect(() => {
        position_1.positionTooltipElementAndShow(tooltipRef.current, clientEl, position, arrowRef.current, delay);
    }, [clientEl, delay, position]);
    // note: tooltip content is scrollable but arrow remains fixed
    // hence we split the portal content into 2 absolutely positioned areas
    return react_dom_1.default.createPortal(jsx_runtime_1.jsxs("div", Object.assign({ className: classes.tooltipBackground }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.tooltipArrowWrapper, ref: arrowRef }, { children: arrowUp || jsx_runtime_1.jsx("div", {}, void 0) }), void 0),
            jsx_runtime_1.jsx("div", Object.assign({ className: classes.tooltipContainer, ref: tooltipRef }, { children: children }), void 0)] }), void 0), portalEl);
};
exports.default = react_jss_1.default(tooltip_style_1.default)(Tooltip);
//# sourceMappingURL=index.js.map